module.exports = __webpack_public_path__ + "img/product_21.0ebc4eb.webp";